<template>
	<v-snackbar
		v-model="show"
		top
		multi-line
		:color="message.type"
		:timeout="message.timeout"
	>
		{{ message.text }}
		<template #action="{ attrs }">
			<v-btn
				text
				icon
				v-bind="attrs"
				@click="() => show = false"
			>
				<v-icon>mdi-close</v-icon>
			</v-btn>
      	</template>
	</v-snackbar>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { alert } from '@/store'

const show = computed({
	get: () => alert.show,
	set: (value: boolean) => alert.setShow(value),
})

const message = computed(() => alert.message)
</script>
